import { withStyles } from '@material-ui/core/styles';
import Switch from '@material-ui/core/Switch';
import FormControlLabel from '@material-ui/core/FormControlLabel';

const SwitchStyled = withStyles((theme) => ({}))(Switch);

const FormControlLabelStyled = withStyles((theme) => ({
  root: {
    '&.MuiFormControlLabel-root': {
      color: theme.palette.form.label,
      fontSize: theme.typography.fontSize,
      marginLeft: 0,
      marginTop: 10,
      marginBottom: 10,
    },
  },
}))(FormControlLabel);

export { SwitchStyled, FormControlLabelStyled };
